<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="aha-modal__header green-bg">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="48"
      viewBox="0 0 52 48"
      fill="none"
    >
      <rect x="3" y="4" width="41" height="41" rx="20.5" fill="#33C173" />
      <mask id="path-2-outside-1_27356_124853" maskUnits="userSpaceOnUse" x="14.2656" y="17.6934" width="20" height="16" fill="black">
        <rect fill="white" x="14.2656" y="17.6934" width="20" height="16" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6758 28.4609L30.3761 18.7698C30.9713 18.1752 31.9357 18.1755 32.5306 18.7703C33.1257 19.3654 33.1257 20.3302 32.5306 20.9253L21.3828 32.0731C20.9922 32.4637 20.3591 32.4637 19.9686 32.0731L15.3493 27.4539C14.7514 26.856 14.7531 25.8861 15.3531 25.2904C15.9501 24.6976 16.9141 24.6993 17.509 25.2942L20.6758 28.4609Z" />
      </mask>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6758 28.4609L30.3761 18.7698C30.9713 18.1752 31.9357 18.1755 32.5306 18.7703C33.1257 19.3654 33.1257 20.3302 32.5306 20.9253L21.3828 32.0731C20.9922 32.4637 20.3591 32.4637 19.9686 32.0731L15.3493 27.4539C14.7514 26.856 14.7531 25.8861 15.3531 25.2904C15.9501 24.6976 16.9141 24.6993 17.509 25.2942L20.6758 28.4609Z" fill="white" />
      <path d="M20.6758 28.4609L20.3223 28.8145L20.6757 29.1679L21.0292 28.8147L20.6758 28.4609ZM15.3493 27.4539L14.9958 27.8075L15.3493 27.4539ZM21.3828 32.0731L21.7363 32.4267L21.3828 32.0731ZM19.9686 32.0731L19.615 32.4267L19.9686 32.0731ZM30.3761 18.7698L30.0227 18.4161L30.3761 18.7698ZM30.0227 18.4161L20.3224 28.1072L21.0292 28.8147L30.7295 19.1236L30.0227 18.4161ZM21.7363 32.4267L32.8841 21.2789L32.177 20.5718L21.0292 31.7196L21.7363 32.4267ZM14.9958 27.8075L19.615 32.4267L20.3221 31.7196L15.7029 27.1003L14.9958 27.8075ZM21.0294 28.1074L17.8626 24.9406L17.1555 25.6477L20.3223 28.8145L21.0294 28.1074ZM15.7054 25.6452C16.107 25.2464 16.7554 25.2476 17.1555 25.6477L17.8626 24.9406C17.0729 24.1509 15.7933 24.1487 15.0008 24.9356L15.7054 25.6452ZM15.7029 27.1003C15.3007 26.6982 15.3019 26.0459 15.7054 25.6452L15.0008 24.9356C14.2044 25.7264 14.2021 27.0138 14.9958 27.8075L15.7029 27.1003ZM21.0292 31.7196C20.8339 31.9148 20.5174 31.9148 20.3221 31.7196L19.615 32.4267C20.2008 33.0125 21.1505 33.0125 21.7363 32.4267L21.0292 31.7196ZM32.177 19.1239C32.5768 19.5237 32.5768 20.172 32.177 20.5718L32.8841 21.2789C33.6745 20.4885 33.6745 19.2071 32.8841 18.4168L32.177 19.1239ZM30.7295 19.1236C31.1294 18.7241 31.7773 18.7242 32.177 19.1239L32.8841 18.4168C32.0941 17.6267 30.8132 17.6264 30.0227 18.4161L30.7295 19.1236Z" fill="white" mask="url(#path-2-outside-1_27356_124853)" />
      <path d="M11.2004 12.2006C7.18402 7.94087 8.85753 2.6162 10.1963 0.486328C8.85759 0.841306 5.77845 1.76425 4.17188 2.6162V2.61644C4.17188 5.81121 4.17188 10.0708 11.2004 12.2006Z" fill="#FDAE2D" />
      <path d="M43.9996 15.4672C47.7305 16.802 48.1727 20.4672 47.9274 22.133C48.6718 21.5226 50.354 20.0553 51.1275 19.0695L51.1275 19.0694C50.2289 17.1698 49.0309 14.6371 43.9996 15.4672Z" fill="#89BEFA" />
      <path d="M34.6289 44.3488C39.3529 42.4185 41.8206 40.379 42.464 39.6006C43.2239 39.6952 45.2054 40.1708 47.0522 41.3165C42.8416 45.6001 38.9633 47.2732 37.5505 47.5743L34.6289 44.3488Z" fill="#FDAE2D" />
      <circle cx="45.0513" cy="36.6802" r="1.05128" fill="#FF4954" />
      <circle cx="5.34286" cy="42.6573" r="2.34286" fill="#348EF6" />
      <circle cx="1.82866" cy="11.0289" r="1.17143" fill="#7669BF" />
    </svg>
    <span class="pl-4 w-11/12" style="font-size: 16px;">
      <h4 class="aha-modal__header--text mb-1">
        <span class="publish-title">{{ headerTitle }}</span>
      </h4>
      <span v-html="headerSubTitle" />
    </span>

    <span class="absolute top-3 right-3">
      <aha-icon
        name="close"
        height="20"
        width="20"
        viewBox="0 0 24 24"
        @click="onClickCloseButton"
        class="cursor-pointer text-base-70 hover:text-primary-90"
      />
    </span>
  </div>
</template>
<script>
export default {
  props: {
    onClickCloseButton: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    headerTitle: {
      type: String,
      required: true,
    },
    headerSubTitle: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.green-bg {
  background-color: #EBF9F1;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  @media (min-width: 768px) {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
}
.publish-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
}
</style>
